import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const AdminBroadcast = () => {
  const [form, setForm] = useState({ subject: "", html_body: "", audience: "all" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/broadcast", form);
      toast.success(`Broadcast sent to ${data.sent} trader(s)`);
      setForm({ subject: "", html_body: "", audience: "all" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Send failed");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-6 max-w-3xl" data-testid="admin-broadcast-page">
      <div>
        <h1 className="font-display text-3xl font-bold">Email Broadcast</h1>
        <p className="text-[#8a8a8a] text-sm mt-1">Send branded campaigns to your trader base.</p>
      </div>
      <form onSubmit={submit} className="glass rounded-xl p-6 space-y-4">
        <div>
          <Label className="text-xs uppercase tracking-wider text-[#cfcfcf]">Audience</Label>
          <Select value={form.audience} onValueChange={(v) => setForm({ ...form, audience: v })}>
            <SelectTrigger className="bg-[#050505] border-[#ff7a00]/20 h-11 mt-2" data-testid="broadcast-audience"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-[#0a0a0a] border-[#ff7a00]/30 text-[#f5f5f5]">
              <SelectItem value="all" className="text-[#f5f5f5]">All Traders</SelectItem>
              <SelectItem value="funded" className="text-[#f5f5f5]">Funded Traders Only</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs uppercase tracking-wider text-[#cfcfcf]">Subject</Label>
          <Input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="bg-[#050505] border-[#ff7a00]/20 h-11 mt-2" placeholder="e.g., Weekly market brief" data-testid="broadcast-subject" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-wider text-[#cfcfcf]">Body (HTML allowed)</Label>
          <Textarea required value={form.html_body} onChange={(e) => setForm({ ...form, html_body: e.target.value })} className="bg-[#050505] border-[#ff7a00]/20 mt-2 min-h-[200px]" placeholder="<p>Hey traders...</p>" data-testid="broadcast-body" />
        </div>
        <Button type="submit" disabled={busy} className="w-full h-11 bg-[#ff7a00] hover:bg-[#ff9a2f] text-[#050505] font-semibold" data-testid="broadcast-submit">
          <Send size={16} className="mr-2" /> {busy ? "Sending..." : "Send Broadcast"}
        </Button>
      </form>
    </div>
  );
};
